import { Injectable } from "@angular/core";
import { BaseService } from "../../services/base/base.service";

@Injectable({
    providedIn: 'root'
})

export class FileManagerService extends BaseService {
    constructor() {
        super('media');
    }

}
